import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { ReadState } from "source/app/services/UI/State/ReadState";


export function GetSpeechItems() {
    const bookOfMindState = ReadState<IBookOfMindState>(
        ESharedFunction.BookOfMind
    );

    if (!bookOfMindState) {
        return [];
    }

    const numberOfQuotesShown = bookOfMindState.numberOfQuotesToDisplay;

    const quotesBeingDisplayed = bookOfMindState.remainingQuotesToDisplay.slice(
        0,
        numberOfQuotesShown
    );

    const speechText = quotesBeingDisplayed.map((bomq) => bomq.quote);
    return speechText;
}
